import { rem, type MantineTheme } from "@mantine/core";
import type { MantineThemeOverride } from "@mantine/core";
import { DROPDOWN_RADIUS, FIELD_RADIUS, MODAL_RADIUS_PX } from "./dashboardTagTokens";

/** Nav, overlays, modal, app shell — second half of dashboard component theme */
export const mantineComponentsChrome: MantineThemeOverride["components"] = {
  NavLink: {
    defaultProps: {
      variant: "filled",
      radius: FIELD_RADIUS,
    },
    styles: (theme: MantineTheme) => ({
      root: {
        borderRadius: rem(FIELD_RADIUS),
        "&:not([data-active]):not([aria-current='page']):not([data-disabled])": {
          color: theme.colors.gray[6],
        },
      },
    }),
  },
  Checkbox: {
    defaultProps: {
      radius: FIELD_RADIUS,
    },
  },

  Popover: {
    defaultProps: {
      shadow: "none",
    },
    styles: {
      dropdown: {
        borderRadius: DROPDOWN_RADIUS,
        border: "1px solid #E3E3E5",
        padding: rem(4),
      },
    },
  },
  HoverCard: {
    defaultProps: {
      shadow: "none",
    },
    styles: {
      dropdown: {
        borderRadius: DROPDOWN_RADIUS,
        border: "1px solid #E3E3E5",
        padding: rem(4),
      },
    },
  },
  Combobox: {
    styles: {
      dropdown: {
        borderRadius: DROPDOWN_RADIUS,
        border: "1px solid #E3E3E5",
        padding: rem(4),
      },
    },
  },
  Select: {
    defaultProps: {
      radius: FIELD_RADIUS,
    },
    styles: {
      dropdown: {
        borderRadius: DROPDOWN_RADIUS,
        border: "1px solid #E3E3E5",
        padding: rem(4),
      },
      input: { borderRadius: FIELD_RADIUS },
    },
  },
  MultiSelect: {
    defaultProps: {
      radius: FIELD_RADIUS,
    },
    styles: {
      dropdown: {
        borderRadius: DROPDOWN_RADIUS,
        border: "1px solid #E3E3E5",
        padding: rem(4),
      },
      input: { borderRadius: FIELD_RADIUS },
    },
  },
  Autocomplete: {
    defaultProps: {
      radius: FIELD_RADIUS,
    },
    styles: {
      dropdown: {
        borderRadius: DROPDOWN_RADIUS,
        border: "1px solid #E3E3E5",
        padding: rem(4),
      },
    },
  },
  TagsInput: {
    defaultProps: {
      radius: FIELD_RADIUS,
    },
    styles: {
      dropdown: {
        borderRadius: DROPDOWN_RADIUS,
        border: "1px solid #E3E3E5",
        padding: rem(4),
      },
    },
  },
  Menu: {
    defaultProps: {
      shadow: "none",
    },
    styles: {
      dropdown: {
        borderRadius: DROPDOWN_RADIUS,
        border: "1px solid #E3E3E5",
        padding: rem(4),
      },
      item: { borderRadius: rem(FIELD_RADIUS) },
    },
  },

  Table: {
    defaultProps: {
      verticalSpacing: "md",
      horizontalSpacing: "md",
      highlightOnHover: true,
    },
    styles: (theme: MantineTheme) => ({
      thead: {
        backgroundColor: theme.colors.gray[0],
      },
      th: {
        fontSize: theme.fontSizes.xs,
        fontWeight: 600,
        color: theme.colors.gray[6],
        textTransform: "uppercase",
        letterSpacing: "0.04em",
        borderBottom: `1px solid ${theme.colors.gray[2]}`,
      },
      td: {
        borderBottom: `1px solid ${theme.colors.gray[2]}`,
      },
    }),
  },

  Accordion: {
    defaultProps: {
      radius: "lg",
    },
  },

  Input: {
    defaultProps: {
      radius: FIELD_RADIUS,
    },
  },
  Modal: {
    defaultProps: {
      closeOnClickOutside: false,
      centered: true,
      radius: MODAL_RADIUS_PX,
      padding: "lg",
    },
    styles: {
      title: { fontWeight: 700 },
      content: { boxShadow: "none" },
    },
  },
  Divider: {
    styles: {
      root: {
        "--divider-color": "#E3E3E5",
      },
      label: {
        color: "#6B7383",
        fontWeight: 600,
        fontSize: "14px",
      },
    },
  },
  AppShell: {
    styles: {
      header: {
        backgroundColor: "#FFFFFF",
        fontWeight: 600,
        fontSize: "14px",
        marginLeft: "25px",
        marginRight: "25px",
        marginTop: "10px",
        borderRadius: "30px",
      },
      navbar: {
        marginLeft: "10px",
        backgroundColor: "#FFFFFF",
        borderRadius: "16px",
        border: "1px solid #E3E3E5",
        top: "calc(var(--app-shell-header-offset, 0rem) + 10px)",
        bottom: "10px",
        height: "auto",
      },
      footer: {
        backgroundColor: "#FFFFFF",
        borderRadius: "30px",
        marginLeft: "25px",
        marginRight: "25px",
        marginBottom: "10px",
      },
      main: {
        backgroundColor: "#F4F4F7",
        color: "#0D0D27",
      },
    },
  },
};
